import { useState } from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ThemeToggler from 'components/common/ThemeToggler';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import AuthService from 'services/auth.service';

const NavItemsSlim = () => {
  const currentUser = AuthService.getCurrentUser();

  const [show, setShow] = useState(false);

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      <Nav.Item>
        <ThemeToggler slim />
      </Nav.Item>
      <Nav.Item>
        <Dropdown
          autoClose={true}
          className="h-100"
          show={show}
          onToggle={setShow}
        >
          <Dropdown.Toggle
            as="div"
            onClick={() => setShow(!show)}
            className="dropdown-caret-none nav-link pe-0 py-0 mt-1 fs-10 cursor-pointer"
            style={{ cursor: 'pointer' }}
          >
            {currentUser.name}
            <FontAwesomeIcon icon={faChevronDown} className="fs-10 ms-1" />
          </Dropdown.Toggle>
          <ProfileDropdownMenu onClose={() => setShow(false)} />
        </Dropdown>
      </Nav.Item>
    </div>
  );
};

export default NavItemsSlim;
